// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.BiColumns = function BiColumns (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M19.893,3.001H4c-1.103,0-2,0.897-2,2v14c0,1.103,0.897,2,2,2h15.893c1.103,0,2-0.897,2-2V8V7V6V5.001V5 C21.892,3.897,20.994,3.001,19.893,3.001z M8,19.001H4V8h4V19.001z M14,19.001h-4V8h4V19.001z M16,19.001V8h3.893l0.001,11.001H16z"}}]})(props);
};
